"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.queryAllPimData = exports.vehicleConfigurationsQuery = void 0;
const types_1 = require("../../../types");
exports.vehicleConfigurationsQuery = `
  query queryVehicleConfigurations($path: String! = "/configurations", $language: String! = "en") {
    catalogue(language: $language, path: $path) {
      children {
        ...item
        ...product
      }
    }
  }
  ${types_1.itemFragment}
  ${types_1.productFragment}
  ${types_1.imageContentFragment}
  ${types_1.singleLineContentFragment}
  ${types_1.richTextContentFragment}
  ${types_1.itemRelationsContentFragment}
  ${types_1.paragraphCollectionContentFragment}
  ${types_1.propertiesTableContentFragment}
  ${types_1.booleanContentFragment}
`;
exports.queryAllPimData = `
  query queryAllPimData($path: String! = "/configurations", $language: String! = "en") {
    catalogue(language: $language, path: $path) {
      ...item
      ...product

      children {
        ...item
        ...product
      }
    }
  }
  ${types_1.allFragments}
`;
//# sourceMappingURL=catalogue.js.map